module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAAf0lEQVRIS2NkgIHpvxIYmBjmM/xjSGTIZFsAF6eAwQjXO+vXfob/DA4MDIwNDOmsjRSYCdeK33CQheSANDZHkDb8hs/89Z9ksxkZDjCMGo4RbKPBgjUljYBgoWkOJTl7omoYwIJr1OUMdK8sRsOcAVb7//8fzJDBvo7CEAFrBwBpIJ4YqqsewAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/maptool/draw/jxq.png
// module id = fqNo
// module chunks = 36